import React from 'react'
import SearchBar from '../components/SearchBar';
import NavBar from '../components/NavBar';

function Header() {
    return (
        <div>
            <SearchBar/>
            <NavBar/>
        </div>
    )
}

export default Header
